import styled from 'styled-components';

import {
  Header, CenteredLoader, Text as TextLayoutComponent, Button as ButtonLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  display: flex;
`;

const Title = styled(Header)`
  margin-bottom: 5px;
`;

const Loader = styled(CenteredLoader)``;

const Text = styled(TextLayoutComponent.Bold)`
  padding-bottom: 15px;
`;

const Button = styled(ButtonLayoutComponent)`
  margin-right: 80px !important;
`;

const UsageHeader = styled.div`
   display: flex;
   justify-content: space-between;
`;

export {
  Loader,
  Title,
  Container,
  Text,
  Button,
  UsageHeader,
};
